export const ivaStatuses = [
  {
    id: '1',
    code: '001',
    label: 'IVA Responsable Inscripto',
  },
  {
    id: '2',
    code: '002',
    label: 'IVA Responsable No Inscripto',
  },
  {
    id: '3',
    code: '003',
    label: 'IVA No Responsable',
  },
  {
    id: '4',
    code: '004',
    label: 'IVA Sujeto Exento',
  },
  {
    id: '5',
    code: '005',
    label: 'Consumidor Final',
  },
  {
    id: '6',
    code: '006',
    label: 'Responsable Monotributo',
  },
  {
    id: '7',
    code: '007',
    label: 'Sujeto no Categorizado',
  },
  {
    id: '8',
    code: '008',
    label: 'Proveedor del Exterior',
  },
  {
    id: '9',
    code: '009',
    label: 'Cliente del Exterior',
  },
  {
    id: '10',
    code: '010',
    label: 'IVA Liberado - Ley N°19.640',
  },
  {
    id: '11',
    code: '011',
    label: 'IVA Responsable Inscripto - Agente de Percepcion',
  },
  {
    id: '12',
    code: '012',
    label: 'Pequeño Contribuyente Eventual',
  },
  {
    id: '13',
    code: '013',
    label: 'Monotributista Social',
  },
  {
    id: '14',
    code: '014',
    label: 'Pequeño Contribuyente Eventual Social',
  },
];
